import script from "./ScrollBar.vue?vue&type=script&lang=js"
export * from "./ScrollBar.vue?vue&type=script&lang=js"

import "../css/ScrollBar.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__